import { render, staticRenderFns } from "./manage-chapters.vue?vue&type=template&id=0f207a14&scoped=true"
import script from "./manage-chapters.vue?vue&type=script&lang=js"
export * from "./manage-chapters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f207a14",
  null
  
)

export default component.exports